import { isRegExp } from 'lodash';

/**
 * Transforms value to the specified regex
 *
 * @param {String} value Value to be applied to the mask.
 * @param {Array} regexp Regexp to be applied in the value.
 */
export default (value = '', regexp) => {
  let result = '';
  let valueIndex = 0;

  regexp.forEach((item) => {
    if (isRegExp(item)) {
      result += value.charAt(valueIndex);
      valueIndex += 1;
    } else {
      result += item;
    }
  });

  return result;
};
